export default "/images/vendor/flag-icons/flags/4x3/sh-ta.svg?63ed20e726909cbb33b251eccf483e06";